import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=53fb2281&scoped=true"
var script = {}
import style0 from "./Order.vue?vue&type=style&index=0&id=53fb2281&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fb2281",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53fb2281')) {
      api.createRecord('53fb2281', component.options)
    } else {
      api.reload('53fb2281', component.options)
    }
    module.hot.accept("./Order.vue?vue&type=template&id=53fb2281&scoped=true", function () {
      api.rerender('53fb2281', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/institutional-trading/components/Order.vue"
export default component.exports